(function($, window, undefined) {
    'use strict';

    function stepController() {
        var controller = this;

        function init() {
            var navListItems = $('ul.setup-panel li a');

            navListItems.click(function(e) {
                var item = $(this).parent('li');

                if (!item.hasClass('disabled')) {
                    navListItems.parent().removeClass('active');
                    item.addClass('active');

                    $('.setup-content').removeClass('active');
                    $($(this).attr('href')).addClass('active');
                    $('body').removeClass('modal-open');
                }
            });
        }

        function disableNextSteps() {
            switch (getActiveStep()) {
                case 1:
                    $('a[href="#step-2"]').parent().addClass('disabled');

                case 2:
                    $('a[href="#step-3"]').parent().addClass('disabled');

                    break;
                default:
                    console.log('step3 doesnt disable steps');
                    //nothing to do
            }
        }

        function enableNextStep() {
            var nextTab = $('ul.setup-panel li.active').next();

            if (nextTab && nextTab.hasClass('disabled')) {
                nextTab.removeClass('disabled');
            }
        }

        function getActiveStep() {
            var activeStep;

            if ($('#step-1').css('display') !== 'none') {
                activeStep = 1;
            }
            if ($('#step-2').css('display') !== 'none') {
                activeStep = 2;
            }
            if ($('#step-3').css('display') !== 'none') {
                activeStep = 3;
            }

            return activeStep;
        }

        function hideErrors() {
            $('.error').hide();
        }

        function errorsAction() {
            $('ul.setup-panel li').unbind('click', hideErrors);
            $('ul.setup-panel li:not(.active):not(.disabled)').bind('click', hideErrors);
        }

        function goToStep(step) {
            if ($('ul.setup-panel li a[href="#step-' + step + '"]').length > 0) {
                $('ul.setup-panel li a[href="#step-' + step + '"]')[0].click();

                errorsAction();
            }
        }

        controller.goToStep = goToStep;
        controller.enableNextStep = enableNextStep;
        controller.getActiveStep = getActiveStep;
        controller.disableNextSteps = disableNextSteps;

        init();

        return controller;
    }

    window.stepController = new stepController();

    $(document).ready(function() {
        $('.backStep').on('click', function(e) {
            window.stepController.goToStep(window.stepController.getActiveStep() - 1);
            $('.error').hide();
        });
    });
})(jQuery, window);